import api from "./api"

/**
 * Registers a new user
 * @param {Object} userObject
 */
export async function register({ userObject }) {
  const requestData = await api.post("/api/v1/authentication", userObject)

  return requestData.data
}
